export default {
  ExaminationResultList: {},
  ExaminationVoucherReferenceList: {
    DateRangePeriod: 'Chọn kỳ báo cáo',
    RefType: 'Loại chứng từ',
  },
  UnaccountedTreasuryList: {
    DateRangePeriod: 'Khoảng thời gian',
  },

  DateRangeFrom: 'Từ',
  DateRangeTo: 'Đến',
};
